import { DatePicker, DateTimePicker } from "@mui/x-date-pickers";
import { useToastContext } from "components/alert/ToastContext";
import AnexoPanel, { getFormData } from "components/anexo/AnexoPanel";
import InputMonetario from "components/input/InputMonetario";
import { Label } from "components/input/Label";
import dayjs from "dayjs";
import ViagemDespesa from "model/viagem/ViagemDespesa";
import ViagemTipoDespesa from "model/viagem/ViagemTipoDespesa";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { InputTextarea } from "primereact/inputtextarea";
import { useLoadingContext } from "provider/LoadingProvider";
import { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import ViagemDespesaService from "service/viagem/ViagemDespesaService";

type Props = {
    visible: boolean;
    onHide: () => void;
    viagemDespesa: ViagemDespesa;
}

const viagemDespesaService = new ViagemDespesaService();
export default function ModalViagemDespesaEditar({ visible, onHide, viagemDespesa }: Props) {
    const { setError, formState: { errors }, register, clearErrors, control } = useForm();
    const { startLoading, stopLoading } = useLoadingContext();
    const { msgSucesso, msgErro, msgAlerta } = useToastContext();

    const [tiposDespesa, setTiposDespesa] = useState<ViagemTipoDespesa[]>([]);

    const [despesa, setDespesa] = useState<ViagemDespesa>({ ...viagemDespesa });
    const [anexos, setAnexos] = useState<any[]>([]);
    const [panelCollapsedAnexos, setPanelCollapsedAnexos] = useState<boolean>(false);

    useEffect(() => {
        viagemDespesaService.getTiposDespesa().then((response) => {
            setTiposDespesa(response)
        }).catch(err => {
            console.error(err);
        });
    }, [])

    function validarDespesa() {
        if (despesa.tipo === null) {
            setError("tipoDespesa", { type: "manual", message: "Tipo é Obrigatório" }, { shouldFocus: true });
            return false;
        }
        if (despesa.dataDespesa === null) {
            setError("dataDespesa", { type: "manual", message: "Data é Obrigatória" }, { shouldFocus: true });
            return false;
        }
        if (despesa.valor === null || despesa.valor === 0) {
            setError("valorDespesa", { type: "manual", message: "Valor é Obrigatório" }, { shouldFocus: true });
            return false;
        }
        return true;
    }

    const salvarDespesas = (despesa: ViagemDespesa) => {
        startLoading();
        viagemDespesaService.salvar(getFormData("despesa", despesa, anexos, "imagens")).then((response) => {
            msgSucesso("Despesa", 'Registro gravado com sucesso');
            onHide();
        }).catch((err) => {
            console.error(err);
            if (err && err.data && err.data.message) {
                msgErro("Despesa", err.data.message);
            } else {
                msgErro("Despesa", 'Ocorreu um erro ao tentar gravar, tente novamente!');
            }
        }).finally(() => {
            stopLoading();
        })
    }

    return (
        <Dialog header="Despesa" visible={visible} style={{ width: '50vw' }}
            onHide={() => {
                onHide();
            }}>
            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Tipo</Label>
                <div className="col-sm-12">
                    <Controller name="tipoDespesa" control={control} render={({ field }) => (
                        <Dropdown
                            focusInputRef={field.ref}
                            className={errors.atividade ? "p-invalid" : ""}
                            options={tiposDespesa}
                            optionLabel="nome"
                            placeholder="Selecione"
                            value={despesa.tipo}
                            style={{ width: '100%' }}
                            onChange={(e) => {
                                setDespesa({ ...despesa, tipo: e.value });
                                clearErrors("tipoDespesa");
                            }}
                        />
                    )} />
                </div>
                {errors.tipoDespesa && errors.tipoDespesa.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.tipoDespesa?.message as string}</span> : null}
            </div>
            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Data da Despesa</Label>
                <div className="col-sm-12">
                    <Controller name="dataDespesa" control={control} render={({ field }) => (
                        <DatePicker
                            value={dayjs(despesa.dataDespesa)}
                            onChange={value => {
                                setDespesa({ ...despesa, dataDespesa: value?.toDate() || null })
                                clearErrors("dataDespesa");
                            }}
                            slotProps={{
                                popper: {
                                    disablePortal: true,
                                    modifiers: [{
                                        name: 'preventOverflow',
                                        enabled: true,
                                        options: {
                                            altAxis: true,
                                        },
                                    }],
                                }
                            }}
                        />
                    )} />
                </div>
                {errors.dataDespesa && errors.dataDespesa.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.dataDespesa?.message as string}</span> : null}
            </div>

            <div className="row">
                <Label className="col col-sm-12">Observação</Label>
                <div className="col-sm-12">
                    <InputTextarea value={despesa.observacao} rows={2} style={{ width: '100%' }}
                        onChange={(e) => {
                            setDespesa({ ...despesa, observacao: e.target.value })
                        }}
                    />
                </div>
            </div>
            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Valor</Label>
                <div className="col-sm-12">
                    <Controller name="valorDespesa" control={control} render={({ field }) => (
                        <InputMonetario value={despesa.valor}
                            onChange={(e) => {
                                setDespesa({ ...despesa, valor: e })
                                clearErrors("valorDespesa")
                            }}
                        />
                    )} />
                </div>
                {errors.valorDespesa && errors.valorDespesa.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.valorDespesa?.message as string}</span> : null}
            </div>
            <div className="row">
                <div className="col-sm-12">
                    <AnexoPanel
                        novosAnexos={anexos} onChangeNovosAnexos={(e: any) => setAnexos(e)}
                        arquivos={despesa.imagens} onChange={(e) => {
                            setDespesa({ ...despesa, imagens: e })
                        }}
                        collapsed={panelCollapsedAnexos} onToggle={(e) => setPanelCollapsedAnexos(e.value)}
                    />
                </div>
            </div>
            <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 16 }}>
                <Button label="Confirmar"
                    onClick={() => {
                        if (validarDespesa()) {
                            salvarDespesas(despesa)
                        }
                    }} style={{ marginLeft: 8 }} />
            </div>

        </Dialog>
    );
}